import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useSendAnalytic = (url, headerToken, authToken) => {
  const [visitorToken, setVisitorToken] = useState("")
  const location = useLocation();

  useEffect(() => {
    const formData = new FormData()
    formData.set("uri", location.pathname)
    if (authToken && authToken.length > 1) {
      formData.set("authToken", authToken)
    }
    if (visitorToken.length > 1) {
      formData.set("visitorToken", visitorToken)
    }
    fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        token: headerToken
      }
    }).then((response) => response.json())
        .then((data) => setVisitorToken(data.visitorToken))
  }, [location.pathname])

};

export default useSendAnalytic;
